"use client";

import { useInfront } from "@/context/infront-context";
import { useEffect, useRef } from "react";

type ChartProps = {
  instrument: {
    feed: number;
    ticker: string;
  };
  periods: string[];
  defaultPeriod?: string;
};

const ID = "compare-chart";

const CompareChart = (props: ChartProps) => {
  const { isReady, load } = useInfront();

  const widgetRef = useRef<any>(null);

  useEffect(() => {
    let active = true;

    load?.(["core", "highstock", "hollowcandlestick", "heikinashi"]).then(() => {
      if (!isReady || !active) return;

      widgetRef.current?.destroy();
      widgetRef.current = null;

      const widgetOptions = new window.Infront.ChartWidgetOptions();

      widgetOptions.instruments = [
        new window.Infront.Instrument(
          props.instrument.feed,
          props.instrument.ticker
        ),
      ];

      widgetOptions.topToolbar = {
        periodMenu: true,
        newCompareMenu: true,
        instrumentHeader: true,
        fullScreenButton: true,
      };

      widgetOptions.instrumentHeader = {
        quoteFields: false,
        chartFields: false,
      };
      widgetOptions.chartType = "baseline";
      widgetOptions.defaultPeriod = props.defaultPeriod;
      widgetOptions.selectablePeriods = props.periods;
      widgetOptions.showPrevClose = false;
      widgetOptions.gridType = "none";
      widgetOptions.showSeriesLabels = false;
      widgetOptions.legendItemClick = "remove";

      widgetOptions.topToolbarLabels = {
        newCompareMenu: {
          isIcon: false,
          value: new window.Infront.Observable("Jämför"),
        },
        periodMenu: {
          isIcon: false,
          value: new window.Infront.Observable("Period"),
        },
      };

      widgetOptions.cursorEventsEnabled = false;
      widgetOptions.selectableNewCompare = {
        list: [
          {
            name: "Nordiska index",
            items: [
              { instrument: { feed: 18177, ticker: "OSEBX" } },
              { instrument: { feed: 18177, ticker: "OBX" } },
              { instrument: { feed: 17921, ticker: "OMXS30" } },
              { instrument: { feed: 17665, ticker: "OMXC20" } },
              { instrument: { feed: 100, ticker: "OMXH25" } },
            ],
          },
        ],
      };

      widgetRef.current = window.infront.chartWidget(`#${ID}`, widgetOptions);
    });

    return () => {
      active = false;
      widgetRef.current?.destroy();
      widgetRef.current = null;
    };
  }, [isReady, props.instrument, props.periods, props.defaultPeriod]);

  return <div className="card h-[300px]" id={ID} />;
};

export default CompareChart;
